'use strict';
import { renderFragment, queryAll } from 'lilly/domUtil';

const flexibleComponentsContainers = queryAll('.js-flexiblecomponents-container');

/**
 * Fetches Flexible Components data for a given URL.
 * @param {string} flexiblecomponentsUrl - The URL to fetch Flexible Components data from.
 * @param {string} productId - The product ID associated with the Shoppable Media data.
 * @param {HTMLElement} flexibleComponentsContainer - The container element to update.
 */
function updateFlexibleComponentsModule(flexiblecomponentsUrl, productId, flexibleComponentsContainer) {
    if (!flexibleComponentsContainer) return;
    // Clear any existing content for shoppable media
    flexibleComponentsContainer.innerHTML = '';
    if (!flexiblecomponentsUrl || !productId) {
        return;
    }
    const $spinner = $(flexibleComponentsContainer).spinner();

    $spinner.start();

    fetch(flexiblecomponentsUrl, { method: 'GET' })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(data => {
            // Clear any existing content
            flexibleComponentsContainer.innerHTML = '';
            // Not JSON, treat as HTML
            if (data) {
                try {
                    const json = JSON.parse(data);
                    if (json && json.error) {
                        return;
                    }
                } catch (error) {
                    // Not JSON, treat as HTML
                }
                flexibleComponentsContainer.appendChild(renderFragment(data));
            }
            $spinner.stop();
            flexibleComponentsContainer.dataset.flexiblecomponentsProductId = productId;
            flexibleComponentsContainer.dataset.flexiblecomponentsUrl = flexiblecomponentsUrl;
        })
        .catch(() => {
            // Clear widget content in case of error in the response
            flexibleComponentsContainer.innerHTML = '';
        })
        .finally(() => {
            $spinner.stop();
        });
}

/**
 * Initializes the shoppable media module.
 * @returns {void}
 */
function initializeFlexibleComponentsModule() {
    if (!flexibleComponentsContainers.length) return;
    flexibleComponentsContainers.forEach(flexibleComponentsContainer => {
        const { flexiblecomponentsUrl, flexiblecomponentsProductId } = flexibleComponentsContainer.dataset;
        updateFlexibleComponentsModule(flexiblecomponentsUrl, flexiblecomponentsProductId, flexibleComponentsContainer);
    });

    // Update widget when swatch is changed
    const $body = $('body');
    $body.on('swatchChangeEvent', (event, el) => {
        if (!el) return;
        const isColorSwatch = el.closest('.js-color-attribute');
        const flexibleComponentsContainer = isColorSwatch.closest('.js-buy-box').querySelector('.js-flexiblecomponents-container');
        if (!isColorSwatch) return;

        const { flexiblecomponentsUrl, productId } = isColorSwatch.dataset;

        updateFlexibleComponentsModule(flexiblecomponentsUrl, productId, flexibleComponentsContainer);
    });
}

initializeFlexibleComponentsModule();
